import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdDirective } from '../ad.directive';
import { AdComponent } from './add-component.interface';
import { DinamicLoaderService } from '../../services/dinamic-loader.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'sous-dinamic-loader',
  templateUrl: './dinamic-loader.component.html',
  styleUrls: ['./dinamic-loader.component.scss'],
})
export class DinamicLoaderComponent implements OnInit, OnDestroy {
  @ViewChild(AdDirective, {static: true}) adHost: AdDirective | undefined;

  private unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private dinamicLoaderService: DinamicLoaderService,
    private componentFactoryResolver: ComponentFactoryResolver) {
    this.dinamicLoaderService.loadComponent$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((obj) => {
        this.loadComponent(obj);
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(false);
    this.unsubscribeAll.complete();
  }


  ngOnInit(): void {

  }

  loadComponent(obj: { component: any; data: any }) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(obj.component);
    const viewContainerRef = this.adHost?.viewContainerRef;
    viewContainerRef?.clear();
    const componentRef = viewContainerRef?.createComponent(componentFactory);
    (<AdComponent>componentRef?.instance).data = obj.data;
  }

}
